import React from 'react';

import { styled } from '@mui/material';

import {
  FacebookIconBlog,
  LinkedinIconBlog,
  XIconBlog,
  XingIconBlog,
} from '@mewa/ui';

export type ArticleThemeAndShareData = {
  shareLink: string;
  shareTitle: string;
};

export const SocialShare = ({
  shareLink,
  shareTitle,
}: ArticleThemeAndShareData) => {
  const encodedLink = encodeURIComponent(shareLink);
  const facebookShareUrl = `https://www.facebook.com/sharer.php?u=${encodedLink}`;
  const linkedInShareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedLink}&title=${encodeURIComponent(shareTitle)}`;
  const xShareUrl = `https://x.com/intent/post?text=+${encodedLink}`;
  const xingShareUrl = `https://www.xing.com/spi/shares/new?url=${encodedLink}`;

  return (
    <ShareIcons>
      <a href={facebookShareUrl} target="_blank" rel="noreferrer">
        <FacebookIconBlog />
      </a>
      <a href={xingShareUrl} target="_blank" rel="noreferrer">
        <XingIconBlog />
      </a>
      <a href={linkedInShareUrl} target="_blank" rel="noreferrer">
        <LinkedinIconBlog />
      </a>
      <a href={xShareUrl} target="_blank" rel="noreferrer">
        <XIconBlog />
      </a>
    </ShareIcons>
  );
};

const ShareIcons = styled('div')(({ theme }) => ({
  a: {
    color: 'var(--color-light-red)',

    svg: {
      width: '50px',
      height: '50px',

      [theme.breakpoints.up('md')]: {
        width: '64px',
        height: '64px',
      },
    },
  },
}));
